const localizedFields = [
  'FORMAT',
  'STATUS',
  'BRANCH',
  'PRIMARY_LANGUAGE',
  'LANGUAGE',
  'FICTION_TYPE',
  'CIRC',
  'TECHNICAL_DIFFICULTY',
  'UGC_RATING',
  'NEWLY_ACQUIRED',
  'AUDIENCE',
  'ON_ORDER'
];

const conjunctiveFields = [
  'NEWLY_ACQUIRED',
  'FICTION_TYPE',
  'GEO_HEADINGS',
  'GENRE_HEADINGS',
  'TOPIC_HEADINGS',
  'AUTHOR',
  'PUBLISHED_DATE',
  'UGC_RATING',
  'TECHNICAL_DIFFICULTY',
  'TAG_GENRE',
  'TAG_TONE',
  'TAG_ABOUT',
  'TAG_PERSONAL'
];

export const isConjunctiveField = fieldId => conjunctiveFields.indexOf(fieldId) >= 0;

export const getLabel = (intl, id, value, singleBranch = false) => {
  if (id === 'STATUS' && singleBranch) {
    return intl.formatMessage({ id: `STATUS.${value.toLowerCase()}.singleBranch` });
  }

  if (localizedFields.indexOf(id) === -1) {
    return value;
  }

  if (id === 'PRIMARY_LANGUAGE') {
    return (
      intl.formatMessage({
        id: `LANGUAGE.${value.toLowerCase()}`,
        defaultMessage: value
      }) || value
    );
  }

  return (
    intl.formatMessage({
      id: `${id}.${value.toLowerCase()}`,
      defaultMessage: value
    }) || value
  );
};
